/* ADONIO košík (#115 + #600). v5 (24. 10. 2026, Dominik k v4): jedna verze (přepínač kosik_v zrušen).
   v6: řazení „Přidej k nákupu“ set → stejná řada + stejná/velmi podobná barva → stejná řada jiná neutrální barva → ostatní.
   v7 (#620): dárek boxerek v řádku nabídky jako nízký rámeček v informačním sloupci pod cenou (fotka, cena přeškrtnutá + ZDARMA),
   každý řádek „Přidej k nákupu“ ve vlastní bublině;
   doručení u každé položky košíku (adoDelivFill, varianta 2: „do“ / „mezi“).
   „Přidej k nákupu“ = kompaktní řádky: oblečení (dvojička do setu za cenu v setu, doporučení Shopify, kolekce
   Essentials ke stejné barvě/kolekci, jen skladem; 5 vidět, další za „Zobrazit další“) + Supreme boxerky a ponožky
   (Bílé / Černé). Velikost je v rozbalovacím výběru PŘEDVYPLNĚNÁ (velikost z košíku, jinak M → L → S…), „Přidat“
   přidá hned. Zachované z v2–v4: set z košíku (_bp + _bid, cena z bundle bloku – slevová funkce „Adonio Bundle sleva“
   dá skutečnou setovou cenu), štítek „+ boxerky ZDARMA“ jen když dárek opravdu přibude (agb-gift.js), výměna dárku
   (barva/velikost se zachováním _gift/_auto), změna velikosti položky, mazání podle klíče (#197), ochrana proti
   „cart:update“ ze setových bloků, schovaný slevový kód, pojištění jako volba.
   Po změně košíku pošle CartAddEvent se sekcemi, takže se drawer i bublina košíku překreslí nativně.
   v11 (Dominik 25. 10. 2026): Supreme trenky/ponožky přes výběr barvy, velikosti a počtu (adoQp*), dárek boxerek za každé
   2 kusy Essentials (adoGiftTopUp), pojištění samotné v košíku se odebere (adoWatch), doporučení podle košíku – Slides,
   UGG, Essentials, jinak bestsellery (AdoRecs), odebrání slevového kódu bez ohledu na velká/malá písmena, vysvětlení
   data doručení po klepnutí (jako na produktu). */
import { CartAddEvent } from '@theme/events';

/* jednotná sada ikon (stejné tvary jako snippets/ado-cart-icon.liquid: 20 px, tah 1,5 px) */
const ADO_IC = {
  gift: '<path d="M2.75 8.25h14.5v9H2.75zM1.75 5.25h16.5v3H1.75zM10 5.25v12M10 5.25C8.75 2.25 5.5 2.5 6.1 4.2c.4 1.05 3.9 1.05 3.9 1.05zM10 5.25c1.25-3 4.5-2.75 3.9-1.05-.4 1.05-3.9 1.05-3.9 1.05z"/>',
  tag: '<path d="M10.6 2.75h6.65V9.4l-7.85 7.85a1.4 1.4 0 0 1-2 0L2.75 12.6a1.4 1.4 0 0 1 0-2z"/><circle cx="13.75" cy="6.25" r="1"/>',
  check: '<path d="m4.5 10.5 3.5 3.5 7.5-8"/>',
  chev: '<path d="m5.75 8 4.25 4.25L14.25 8"/>',
};
function adoIcon(n) {
  return `<svg class="adoc-ic" viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${ADO_IC[n] || ''}</svg>`;
}

function sectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => ids.add(el.dataset.sectionId));
  return [...ids];
}

async function cartRequest(url, body) {
  const ids = sectionIds();
  if (ids.length) {
    body.sections = ids.join(',');
    body.sections_url = window.location.pathname;
  }
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok || data.status) throw new Error(data.description || data.message || 'cart error');
  let itemCount = data.item_count;
  if (itemCount === undefined) {
    try {
      itemCount = (await (await fetch('/cart.js', { cache: 'no-store' })).json()).item_count;
    } catch (e) {}
  }
  document.dispatchEvent(
    new CartAddEvent({}, 'ado-cart', { source: 'ado-cart', itemCount: itemCount || 0, sections: data.sections || {} })
  );
  return data;
}

async function rawAdd(items) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items }),
  });
  const data = await res.json();
  if (!res.ok || data.status) throw new Error(data.description || data.message || 'cart error');
  return data;
}

/* EU expanze (#801): PLN, RON, HUF jen přes ADO.money z ado-market (1.099,99 zł · 1.099 lei · 39 990 Ft); CZK a EUR beze změny */
const adoEu = (cur) => cur === 'PLN' || cur === 'RON' || cur === 'HUF';
function adoMoney(cents, cur, loc) {
  if (adoEu(cur) && window.ADO && typeof window.ADO.money === 'function') return window.ADO.money(cents, { cur });
  const v = Number(cents) / 100;
  if (cur === 'CZK') return Math.round(v).toLocaleString('cs-CZ') + ' Kč';
  const fd = Number.isInteger(v) ? 0 : 2;
  try {
    return new Intl.NumberFormat(loc || 'cs-CZ', { style: 'currency', currency: cur, minimumFractionDigits: fd, maximumFractionDigits: fd }).format(v);
  } catch (e) {
    return v + ' ' + cur;
  }
}
function adoEsc(s) {
  const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => map[c]);
}
/* cena kusu v setu – stejně jako slevová funkce: _bp = podíl slevy × 1e8, CZK na celé koruny, jinak na centy */
function adoSetPrice(cents, bp, cur) {
  const raw = Number(cents) * (1 - Number(bp) / 1e8);
  return cur === 'CZK' ? Math.round(raw / 100) * 100 : Math.round(raw);
}

/* ---------- řádky „Přidej k nákupu“ (v5): barva (boxerky/ponožky), předvyplněná velikost, Přidat ---------- */
function card(el) {
  return el.closest('[data-adoc-card]');
}
/* vybraná varianta řádku = hodnota viditelného výběru velikosti (u ponožek / jedné velikosti skrytý výběr s 1 volbou) */
function rowSelect(c) {
  const col = c.dataset.color;
  return c.querySelector(col ? `select[data-adoc-psize][data-adoc-c="${col}"]` : 'select[data-adoc-psize]');
}
function rowVid(c) {
  const s = rowSelect(c);
  return s ? Number(s.value) : 0;
}
/* karta setu / doporučení: cena podle zvolené velikosti (velikosti můžou mít různé ceny) */
function rowPrice(c) {
  const s = rowSelect(c);
  const o = s && s.options[s.selectedIndex];
  if (!o) return;
  const pe = c.querySelector('[data-adoc-cprice]');
  if (pe && o.dataset.p) pe.textContent = o.dataset.p;
  const ps = c.querySelector('[data-adoc-cstrike]');
  if (ps) {
    ps.textContent = o.dataset.s || '';
    ps.hidden = !o.dataset.s;
  }
}
function rowReset(c) {
  const add = c.querySelector('[data-adoc-add]');
  if (!add || c.classList.contains('is-added')) return;
  add.disabled = false;
  add.textContent = add.getAttribute('data-adoc-label');
}

document.addEventListener('click', async (e) => {
  const t = e.target instanceof Element ? e.target : null;
  if (!t) return;

  /* v11: Supreme – „Přidat“ jen rozbalí výběr barvy, velikosti a počtu přímo v kartě */
  const qpc = t.closest('[data-adoc-qp]');
  if (qpc) {
    const open = t.closest('[data-adoc-open]');
    if (open) {
      const panel = qpc.querySelector('[data-adoc-qpanel]');
      if (panel) panel.hidden = false;
      qpc.classList.add('is-open');
      open.setAttribute('aria-expanded', 'true');
      adoQpRender(qpc);
      return;
    }
    const col = t.closest('[data-adoc-color]');
    if (col) {
      const k = col.getAttribute('data-adoc-color');
      const prevSz = qpc.querySelector(`[data-adoc-szg="${qpc.dataset.color}"] [data-adoc-sz].is-on`);
      qpc.dataset.color = k;
      qpc.querySelectorAll('[data-adoc-color]').forEach((b) => {
        b.classList.toggle('is-on', b === col);
        b.setAttribute('aria-checked', b === col ? 'true' : 'false');
      });
      qpc.querySelectorAll('[data-adoc-img]').forEach((i) => (i.hidden = i.getAttribute('data-adoc-img') !== k));
      qpc.querySelectorAll('[data-adoc-szg]').forEach((g) => {
        const mine = g.getAttribute('data-adoc-szg') === k;
        g.hidden = !mine || g.classList.contains('is-one');
        if (mine && prevSz) {
          /* stejná velikost i v druhé barvě, když je skladem */
          const same = [...g.querySelectorAll('[data-adoc-sz]')].find((x) => x.textContent.trim() === prevSz.textContent.trim());
          if (same) adoQpPick(g, same);
        }
      });
      adoQpRender(qpc);
      return;
    }
    const sz = t.closest('[data-adoc-sz]');
    if (sz) {
      adoQpPick(sz.closest('[data-adoc-szg]'), sz);
      adoQpRender(qpc);
      return;
    }
    const q = t.closest('[data-adoc-q]');
    if (q && !q.disabled) {
      qpc.dataset.q = q.getAttribute('data-adoc-q');
      adoQpRender(qpc);
      return;
    }
    const qadd = t.closest('[data-adoc-qadd]');
    if (qadd && !qadd.disabled) {
      const sel = adoQpSel(qpc);
      const n = Number(qpc.dataset.q) || 1;
      if (!sel) return;
      qadd.disabled = true;
      qadd.textContent = qadd.getAttribute('data-adoc-busy');
      try {
        await cartRequest('/cart/add.js', { items: [{ id: sel.vid, quantity: n }] });
        qpc.classList.add('is-added');
        qadd.innerHTML = adoIcon('check') + adoEsc(qadd.getAttribute('data-adoc-done') || '');
      } catch (err) {
        qadd.disabled = false;
        qadd.textContent = err.message || 'Error';
      }
      return;
    }
  }

  const color = t.closest('[data-adoc-color]');
  if (color) {
    const c = card(color);
    const k = color.getAttribute('data-adoc-color');
    c.dataset.color = k;
    c.querySelectorAll('[data-adoc-color]').forEach((b) => {
      b.classList.toggle('is-on', b === color);
      b.setAttribute('aria-checked', b === color ? 'true' : 'false');
    });
    c.querySelectorAll('[data-adoc-img]').forEach((i) => (i.hidden = i.getAttribute('data-adoc-img') !== k));
    /* stejná velikost i v druhé barvě, když je skladem */
    const prev = [...c.querySelectorAll('select[data-adoc-psize]')].find((s) => !s.hidden);
    const want = prev && prev.options[prev.selectedIndex] ? prev.options[prev.selectedIndex].textContent.trim() : '';
    c.querySelectorAll('select[data-adoc-psize]').forEach((s) => {
      const mine = s.getAttribute('data-adoc-c') === k;
      s.hidden = !mine || s.classList.contains('is-one');
      if (mine && want) {
        const o = [...s.options].find((x) => x.textContent.trim() === want);
        if (o) s.value = o.value;
      }
    });
    rowReset(c);
    return;
  }

  const more = t.closest('[data-adoc-more]');
  if (more) {
    const box = more.closest('ado-recs') || document;
    box.querySelectorAll('.adoc-row.is-more').forEach((r) => r.classList.remove('is-more'));
    more.remove();
    return;
  }

  const add = t.closest('[data-adoc-add]');
  if (add && !add.disabled) {
    const c = card(add);
    const vid = rowVid(c);
    if (!vid) return;
    add.disabled = true;
    add.textContent = add.getAttribute('data-adoc-busy');
    try {
      if (c.dataset.adocKind === 'set') await addSet(c, vid);
      else {
        const it = { id: vid, quantity: 1 };
        const pr = propsOf(c);
        if (Object.keys(pr).length) it.properties = pr;
        await cartRequest('/cart/add.js', { items: [it] });
      }
      add.innerHTML = adoIcon('check') + adoEsc(add.getAttribute('data-adoc-done') || '');
      c.classList.add('is-added');
    } catch (err) {
      add.disabled = false;
      add.textContent = err.message || 'Error';
    }
    return;
  }

  const ins = t.closest('[data-adoc-ins]');
  if (ins) {
    if (ins.classList.contains('is-busy')) return;
    ins.classList.add('is-busy');
    const key = ins.getAttribute('data-adoc-key');
    ins.setAttribute('aria-checked', key ? 'false' : 'true');
    try {
      if (key) await cartRequest('/cart/change.js', { id: key, quantity: 0 });
      else await cartRequest('/cart/add.js', { items: [{ id: Number(ins.getAttribute('data-adoc-ins')), quantity: 1 }] });
    } catch (err) {
      ins.setAttribute('aria-checked', key ? 'true' : 'false');
    }
    ins.classList.remove('is-busy');
    return;
  }

  /* dárek v košíku: jiná barva → stejná velikost v druhé barvě (nebo M / první dostupná) */
  const gc = t.closest('[data-adoc-gc]');
  if (gc && !gc.disabled && !gc.classList.contains('is-on')) {
    const w = gc.closest('[data-adoc-giftsw]');
    const map = {};
    String(gc.getAttribute('data-adoc-map') || '')
      .split(',')
      .filter(Boolean)
      .forEach((p) => {
        const i = p.lastIndexOf(':');
        map[p.slice(0, i)] = p.slice(i + 1);
      });
    const sizes = Object.keys(map);
    const want = w.getAttribute('data-adoc-size');
    const vid = map[want] || map.M || map[sizes[0]];
    if (!vid) return;
    await swapLine(w, Number(vid));
  }
});

/* ---------- v11: výběr počtu Supreme trenek / ponožek ----------
   Ceny = skutečné automatické slevy Shopify „Supreme 2ks / 3ks / 4ks“ (a „Supreme ponozky …“): −90 / −180 / −370 Kč
   z košíku (ověřeno /cart.js: 490 / 890 / 1 290 / 1 590 Kč, i při míchání barev). V jiné měně Shopify přepočítá
   pevnou slevu kurzem trhu (Shopify.currency.rate) – stejně se počítá tady. data-tok="0" = v košíku je jiná sleva
   (dárek / set Essentials, Slides, kód…), se kterou se slevy Supreme nesčítají → bez cen za kusy. */
function adoConv(cents, cur) {
  if (!cents || cur === 'CZK') return cents;
  const r = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 0;
  return r ? Math.round(cents * r) : null;
}
function adoLastTxt(n, lw) {
  const w = String(lw || '').split('|');
  const i = n === 1 ? 0 : n <= 4 ? 1 : 2;
  return `${adoEsc(w[i] || '')} <b>${n} ${adoEsc(w[3 + i] || '')}</b> ${adoEsc(w[6] || '')}`;
}
function adoQpPick(g, b) {
  if (!g || !b) return;
  g.querySelectorAll('[data-adoc-sz]').forEach((x) => {
    x.classList.toggle('is-on', x === b);
    x.setAttribute('aria-checked', x === b ? 'true' : 'false');
  });
}
function adoQpSel(c) {
  const g = c.querySelector(`[data-adoc-szg="${c.dataset.color}"]`);
  const b = g && (g.querySelector('[data-adoc-sz].is-on') || g.querySelector('[data-adoc-sz]'));
  if (!b) return null;
  return { vid: Number(b.dataset.vid), inv: b.dataset.inv === '' || b.dataset.inv == null ? null : Number(b.dataset.inv) };
}
function adoQpPrice(c, q) {
  const full = Number(c.dataset.unit) * q;
  if (c.dataset.tok !== '1' || adoEu(c.dataset.cur)) return { now: full, full };
  const t = Number((c.dataset.tiers || '').split(',')[q - 1]) || 0;
  const d = adoConv(t, c.dataset.cur);
  if (d == null) return { now: full, full };
  return { now: full - d, full };
}
function adoQpRender(c) {
  const M = (x) => adoMoney(x, c.dataset.cur, c.dataset.loc);
  const sel = adoQpSel(c);
  const inv = sel ? sel.inv : null;
  let q = Number(c.dataset.q) || 1;
  if (inv != null && inv > 0 && q > inv) q = inv;
  c.dataset.q = String(q);
  c.querySelectorAll('[data-adoc-q]').forEach((b) => {
    const n = Number(b.getAttribute('data-adoc-q'));
    const pr = adoQpPrice(c, n);
    const pe = b.querySelector('[data-adoc-qprice]');
    if (pe) pe.textContent = M(pr.now);
    const se = b.querySelector('[data-adoc-qstrike]');
    if (se) {
      se.hidden = !(pr.now < pr.full);
      se.textContent = pr.now < pr.full ? M(pr.full) : '';
    }
    b.disabled = inv != null && n > inv;
    b.classList.toggle('is-on', n === q);
    b.setAttribute('aria-checked', n === q ? 'true' : 'false');
  });
  const add = c.querySelector('[data-adoc-qadd]');
  if (add && !c.classList.contains('is-added')) {
    add.disabled = !sel;
    add.textContent = `${c.dataset.tAdd} ${q} ${c.dataset.pcs} · ${M(adoQpPrice(c, q).now)}`;
  }
  /* poslední kusy jen podle skutečného skladu vybrané varianty a jen ≤ 9 */
  const last = c.querySelector('[data-adoc-qlast]');
  if (last) {
    const show = inv != null && inv > 0 && inv <= 9;
    last.hidden = !show;
    last.innerHTML = show ? adoLastTxt(inv, c.dataset.lw) : '';
  }
  const note = c.querySelector('[data-adoc-tnote]');
  if (note) {
    const p2 = adoQpPrice(c, 2);
    const on = c.dataset.tok === '1' && p2.now < p2.full;
    note.hidden = !on;
    note.textContent = on ? `2 ${c.dataset.tier || ''} ${M(p2.now)}` : '';
  }
  c.dataset.qpReady = '1';
}

/* změna předvyplněné velikosti v řádku nabídky → jen přepočítat cenu, nic nepřidat */
document.addEventListener('change', (e) => {
  const s = e.target instanceof Element ? e.target.closest('select[data-adoc-psize]') : null;
  if (!s) return;
  const c = card(s);
  rowPrice(c);
  rowReset(c);
});

/* ---------- výměna řádku (velikost položky, barva/velikost dárku) ----------
   Nejdřív přidá novou variantu se stejným množstvím a vlastnostmi (set _bp/_bid, dárek _gift/_auto), pak odebere
   původní řádek – nic se neztratí, když nová varianta nejde přidat, a dárek ani na chvíli nezmizí (agb-gift.js). */
function propsOf(el) {
  let props = {};
  try {
    props = JSON.parse(el.getAttribute('data-adoc-props') || '{}') || {};
    /* Liquid | json dává vlastnosti jako pole dvojic [[klíč, hodnota], …] */
    if (Array.isArray(props)) props = Object.fromEntries(props.filter((p) => Array.isArray(p) && p.length === 2));
  } catch (err) {
    props = {};
  }
  return props;
}
async function swapLine(el, newVid) {
  const key = el.getAttribute('data-adoc-key');
  const qty = Number(el.getAttribute('data-adoc-lqty')) || 1;
  const props = propsOf(el);
  const item = { id: newVid, quantity: qty };
  if (props && Object.keys(props).length) item.properties = props;
  document.querySelectorAll('cart-items-component').forEach((c) => c.classList.add('cart-items-disabled'));
  try {
    await rawAdd([item]);
    /* klíč řádku se po přidání může změnit (Shopify ho přepočítá kvůli slevám) → dohledat původní řádek znovu */
    const oldVid = Number(String(key).split(':')[0]);
    const same = (a, b) => JSON.stringify(Object.entries(a || {}).sort()) === JSON.stringify(Object.entries(b || {}).sort());
    const cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
    const old = cart.items.find((i) => i.key === key) || cart.items.find((i) => i.variant_id === oldVid && same(i.properties, props));
    if (old) await cartRequest('/cart/change.js', { id: old.key, quantity: Math.max(0, old.quantity - qty) });
    else await adoRefreshCart();
    return true;
  } catch (err) {
    alert(err.message || 'Error');
    await adoRefreshCart();
    return false;
  } finally {
    document.querySelectorAll('cart-items-component').forEach((c) => c.classList.remove('cart-items-disabled'));
  }
}

document.addEventListener('change', async (e) => {
  const sel = e.target instanceof Element ? e.target : null;
  if (!sel) return;
  const gs = sel.closest('[data-adoc-gs]');
  if (gs) {
    const w = gs.closest('[data-adoc-giftsw]');
    gs.disabled = true;
    await swapLine(w, Number(gs.value));
    return;
  }
  const v = sel.closest('.adoc-var[data-adoc-key]');
  if (!v) return;
  const prev = v.querySelector('option[selected]');
  v.disabled = true;
  const ok = await swapLine(v, Number(v.value));
  if (!ok) {
    if (prev) v.value = prev.value;
    v.disabled = false;
  }
});

/* ---------- set z košíku: kus Essentials + jeho dvojička za cenu v setu ---------- */
async function addSet(c, partnerVid) {
  const mainVid = Number(c.dataset.mainVid);
  const bid = 'b' + Date.now() + '-' + Math.floor(Math.random() * 100000);
  /* stejné vlastnosti jako tlačítko setu na produktu (bundle blok essentials-gift) */
  await rawAdd([
    { id: mainVid, quantity: 1, properties: { _bp: String(c.dataset.bpMain || '0'), _bid: bid } },
    { id: partnerVid, quantity: 1, properties: { _bp: String(c.dataset.bpPartner || '0'), _bid: bid } },
  ]);
  /* původní samostatný kus (bez _bp) se odebere – v košíku zůstane jen set */
  const cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
  const old = cart.items.find(
    (i) => i.variant_id === mainVid && !(i.properties && (i.properties._bp || i.properties._gift))
  );
  if (old) await cartRequest('/cart/change.js', { id: old.key, quantity: Math.max(0, old.quantity - 1) });
  else await adoRefreshCart();
}

/* Údaje o setu bere košík přímo z bundle bloku produktu (data-bp1/bp2 + dvojička), takže sedí s tím,
   co účtuje slevová funkce. Na stránce produktu se uloží hned (bez dalšího stahování), jinak se stránka
   produktu načte jen do místa, kde je bundle blok (čtení se pak přeruší), a výsledek se pamatuje v sessionStorage. */
function adoCur() {
  return (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
}
function setKey(h) {
  return 'adoSet1:' + h + ':' + adoCur();
}
function parseAgb(html) {
  const i = html.indexOf('<div class="agb"');
  if (i < 0) return null;
  const tag = html.slice(i, html.indexOf('>', i));
  const attr = (n) => (tag.match(new RegExp(n + '="([^"]*)"')) || [])[1] || '';
  const mode = attr('data-mode');
  if (mode !== 'dvojce') return { mode };
  const j = html.indexOf('data-role="set-partner"', i);
  if (j < 0) return null;
  const seg = html.slice(i, j);
  const links = [...seg.matchAll(/class="agb__iname" href="\/products\/([^"?#]+)"/g)];
  const partner = links.length ? links[links.length - 1][1] : '';
  return { mode, bp1: attr('data-bp1'), bp2: attr('data-bp2'), partner };
}
function rememberSetFromPage() {
  try {
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    const agb = document.querySelector('.agb[data-mode]');
    if (!m || !agb) return;
    let info = { mode: agb.dataset.mode };
    if (info.mode === 'dvojce') {
      const sel = agb.querySelector('[data-role="set-partner"]');
      const a = sel && sel.closest('.agb__item') && sel.closest('.agb__item').querySelector('a.agb__iname');
      const ph = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!ph) return;
      info = { mode: 'dvojce', bp1: agb.dataset.bp1, bp2: agb.dataset.bp2, partner: ph[1] };
    }
    sessionStorage.setItem(setKey(decodeURIComponent(m[1])), JSON.stringify(info));
  } catch (e) {}
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rememberSetFromPage);
else rememberSetFromPage();

const adoSetCache = new Map();
function adoSetInfo(handle) {
  if (adoSetCache.has(handle)) return adoSetCache.get(handle);
  const p = (async () => {
    try {
      const s = sessionStorage.getItem(setKey(handle));
      if (s) return JSON.parse(s);
    } catch (e) {}
    let info = null;
    try {
      const r = await fetch('/products/' + encodeURIComponent(handle));
      if (r.ok && r.body && r.body.getReader) {
        const reader = r.body.getReader();
        const dec = new TextDecoder();
        let buf = '';
        for (;;) {
          const { done, value } = await reader.read();
          if (value) buf += dec.decode(value, { stream: true });
          const i = buf.indexOf('<div class="agb"');
          if (i > -1) {
            const end = buf.indexOf('</select>', buf.indexOf('data-role="set-partner"', i));
            const tagEnd = buf.indexOf('>', i);
            if (tagEnd > -1 && !/data-mode="dvojce"/.test(buf.slice(i, tagEnd))) {
              info = parseAgb(buf);
              break;
            }
            if (end > -1) {
              info = parseAgb(buf);
              break;
            }
          }
          if (done || buf.length > 3e6) break;
        }
        try {
          reader.cancel();
        } catch (e) {}
      }
    } catch (e) {}
    if (!info) info = { mode: '' };
    try {
      sessionStorage.setItem(setKey(handle), JSON.stringify(info));
    } catch (e) {}
    return info;
  })();
  adoSetCache.set(handle, p);
  return p;
}
const adoProdCache = new Map();
function adoProduct(handle) {
  if (!adoProdCache.has(handle))
    adoProdCache.set(
      handle,
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null)
    );
  return adoProdCache.get(handle);
}

/* ---------- přidání z formuláře produktu → otevřít košík ---------- */
document.addEventListener('cart:update', (e) => {
  const d = e.detail && e.detail.data;
  if (!d || d.source !== 'product-form-component' || d.didError) return;
  setTimeout(() => {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function' && !drawer.querySelector('dialog[open]')) drawer.open();
  }, 60);
});

/* Starší skripty (setové bloky Essentials/YS-01, auto-dárek agb-gift.js) po přidání do košíku:
   1) pošlou 'cart:update' bez detail.data → téma na tom padá a bublina ukáže 0,
   2) stáhnou /cart?section_id=<hlavička> a přepíšou jí celou hlavičku → zmizí otevíratelný košík
      a „otevřít košík“ míří na odpojený prvek (košík se ukázal až po refreshi).
   Tady: neúplné události zastavíme a místo přepsání hlavičky košík překreslíme nativně (sekce + CartAddEvent),
   takže jejich následné drawer.open() otevře skutečný, aktuální košík. */
let adoRefreshing = null;
async function adoRefreshCart() {
  if (adoRefreshing) return adoRefreshing;
  adoRefreshing = (async () => {
    try {
      const ids = sectionIds();
      const [cart, sections] = await Promise.all([
        fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json()),
        ids.length
          ? fetch(`${window.location.pathname}?sections=${ids.join(',')}`, { cache: 'no-store' }).then((r) => r.json())
          : Promise.resolve({}),
      ]);
      document.dispatchEvent(
        new CartAddEvent({}, 'ado-cart', { source: 'ado-cart', itemCount: cart.item_count || 0, sections: sections || {} })
      );
    } catch (e) {}
  })();
  try {
    await adoRefreshing;
  } finally {
    adoRefreshing = null;
  }
}

document.addEventListener(
  'cart:update',
  (e) => {
    if (e.detail && e.detail.data) return;
    e.stopImmediatePropagation();
    adoRefreshCart();
  },
  true
);

if (!window.__adoCartFetchPatched) {
  window.__adoCartFetchPatched = true;
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      const raw = typeof input === 'string' ? input : input instanceof URL ? input.href : input && input.url;
      const url = raw ? new URL(raw, window.location.origin) : null;
      const sid = url && url.searchParams.get('section_id');
      if (
        url &&
        url.origin === window.location.origin &&
        url.pathname === '/cart' &&
        window.location.pathname !== '/cart' &&
        sid &&
        [...url.searchParams.keys()].length === 1 &&
        sectionIds().indexOf(sid) > -1
      ) {
        return adoRefreshCart().then(
          () => new Response('<div></div>', { status: 200, headers: { 'Content-Type': 'text/html' } })
        );
      }
      /* #197: odebrání / změna množství v košíku podle klíče položky, ne podle čísla řádku */
      if (
        adoLineKeys &&
        url &&
        url.origin === window.location.origin &&
        /^\/cart\/change(\.js)?$/.test(url.pathname) &&
        init &&
        typeof init.body === 'string'
      ) {
        const keys = adoLineKeys;
        adoLineKeys = null;
        const body = JSON.parse(init.body);
        const domKey = body && body.line && !body.id ? keys[body.line - 1] : '';
        if (domKey) {
          const self = this;
          return adoResolveLineKey(origFetch, domKey, keys).then((key) => {
            if (!key) {
              /* položka už v košíku není → nic neměnit, jen vrátit aktuální košík se sekcemi */
              const upd = { updates: {} };
              if (body.sections) upd.sections = body.sections;
              if (body.sections_url) upd.sections_url = body.sections_url;
              return origFetch.call(self, '/cart/update.js', Object.assign({}, init, { body: JSON.stringify(upd) }));
            }
            delete body.line;
            body.id = key;
            return origFetch.call(self, input, Object.assign({}, init, { body: JSON.stringify(body) }));
          });
        }
      }
    } catch (e) {}
    return origFetch.apply(this, arguments);
  };
}

/* #197: Horizon maže a mění množství podle ČÍSLA řádku (line). Když se košík mezitím změní
   (automaticky přidaný dárek, přidání v jiné záložce, košík ještě nepřekreslený), číslo ukazuje
   na jinou položku → zákazník odebere mikinu a zmizí mu tričko (mikina „se vrací“). Proto si
   při každé změně zapamatujeme klíče řádků, jak je zákazník vidí, a v aktuálním košíku
   dohledáme položku, na kterou opravdu klikl. */
let adoLineKeys = null;
customElements.whenDefined('cart-items-component').then((C) => {
  const proto = C && C.prototype;
  if (!proto || proto.__adoKeyPatch || typeof proto.updateQuantity !== 'function') return;
  proto.__adoKeyPatch = true;
  const orig = proto.updateQuantity;
  proto.updateQuantity = function (config) {
    try {
      adoLineKeys = [...(this.refs.cartItemRows || [])].map((r) => (r && r.dataset && r.dataset.key) || '');
    } catch (e) {
      adoLineKeys = null;
    }
    try {
      return orig.call(this, config);
    } finally {
      adoLineKeys = null;
    }
  };
});

async function adoResolveLineKey(origFetch, domKey, keys) {
  const cart = await (await origFetch('/cart.js', { cache: 'no-store' })).json();
  const items = cart.items || [];
  if (items.some((i) => i.key === domKey)) return domKey;
  /* klíč se mohl změnit (slevy) → stejná varianta; u více řádků téže varianty podle pořadí */
  const vid = String(domKey).split(':')[0];
  const same = items.filter((i) => String(i.variant_id) === vid);
  if (!same.length) return null;
  const pos = keys.filter((k) => String(k).split(':')[0] === vid).indexOf(domKey);
  return (same[pos] || same[0]).key;
}

/* ---------- schovaný slevový kód ---------- */
document.addEventListener('submit', async (e) => {
  const form = e.target instanceof Element ? e.target.closest('[data-adoc-code]') : null;
  if (!form) return;
  e.preventDefault();
  const input = form.querySelector('input');
  const code = (input.value || '').trim();
  if (!code) return;
  const bad = form.getAttribute('data-adoc-bad');
  const btn = form.querySelector('button');
  btn.disabled = true;
  const showBad = () => {
    const m = document.querySelector('dialog[open] [data-adoc-code-msg], .adoc-page [data-adoc-code-msg]');
    if (m) {
      m.textContent = bad;
      m.hidden = false;
    }
  };
  try {
    const cur = await (await fetch('/cart.js', { cache: 'no-store' })).json();
    const codes = (cur.discount_codes || []).map((d) => d.code).filter((c) => c.toLowerCase() !== code.toLowerCase());
    codes.push(code);
    const data = await cartRequest('/cart/update.js', { discount: codes.join(',') });
    const hit = (data.discount_codes || []).find((d) => String(d.code).toLowerCase() === code.toLowerCase());
    if (!hit || !hit.applicable) {
      await cartRequest('/cart/update.js', { discount: codes.filter((c) => c !== code).join(',') });
      showBad();
    }
  } catch (err) {
    showBad();
  }
  btn.disabled = false;
});

document.addEventListener('click', async (e) => {
  const rm = e.target instanceof Element ? e.target.closest('[data-adoc-code-rm]') : null;
  if (!rm) return;
  e.preventDefault();
  e.stopPropagation();
  if (rm.disabled) return;
  rm.disabled = true;
  /* v11: kód v košíku bývá zadaný malými písmeny („zpet-…“), štítek ukazuje název slevy velkými – dřív se proto
     neodebralo nic (porovnání rozlišovalo velikost písmen). Teď bez ohledu na velikost písmen; když kód po odebrání
     v košíku pořád je, smažou se všechny a ostatní se vrátí. */
  const low = String(rm.getAttribute('data-code') || '').toLowerCase();
  const same = (d) => String(d.code || '').toLowerCase() === low;
  try {
    const cur = await (await fetch('/cart.js', { cache: 'no-store' })).json();
    const rest = (cur.discount_codes || []).filter((d) => d.code && !same(d)).map((d) => d.code);
    const data = await cartRequest('/cart/update.js', { discount: rest.join(',') });
    if ((data.discount_codes || []).some(same)) {
      await cartRequest('/cart/update.js', { discount: '' });
      if (rest.length) await cartRequest('/cart/update.js', { discount: rest.join(',') });
    }
    const tag = rm.closest('.adoc-code__tag');
    if (tag) tag.remove();
  } catch (err) {
    rm.disabled = false;
  }
});

/* ---------- #665 HALLOWEEN: „Uplatnit kód HALLOWEEN10“ (snippets/ado-halloween.liquid, part 'cart') ----------
   v2: hned po kliku stav „Uplatňuji…“ (i na tlačítku, které vznikne překreslením košíku). Kód se přidá k ostatním
   kódům v košíku. Když ho Shopify neuplatní (applicable: false – kód je vypnutý / mimo platnost, nebo košík má
   automatickou slevu, se kterou se nesčítá), kód zase odebereme a napíšeme „Kód HALLOWEEN10 teď nejde uplatnit“
   + „– v košíku už máš výhodnější slevu“ jen když košík opravdu automatickou slevu má (line_level_discount_allocations
   / cart_level_discount_applications). Po uplatnění košík překreslí Liquid a ukáže „Kód HALLOWEEN10 uplatněn – ušetříš X“. */
function adoHwBusy(on) {
  document.querySelectorAll('[data-ado-hw-apply]').forEach((b) => {
    const box = b.closest('[data-ado-hw-cart]');
    /* mění se jen text vedle ikony netopýra (span data-ado-hw-bl), ikona zůstává */
    const l = b.querySelector('[data-ado-hw-bl]') || b;
    if (!b.dataset.lbl) b.dataset.lbl = l.innerHTML;
    b.disabled = on;
    b.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) l.textContent = (box && box.getAttribute('data-busy')) || l.textContent;
    else l.innerHTML = b.dataset.lbl;
  });
}
document.addEventListener('click', async (e) => {
  const btn = e.target instanceof Element ? e.target.closest('[data-ado-hw-apply]') : null;
  if (!btn) return;
  e.preventDefault();
  if (btn.disabled) return;
  document.querySelectorAll('[data-ado-hw-msg]').forEach((m) => { m.hidden = true; });
  adoHwBusy(true);
  const code = btn.getAttribute('data-ado-hw-apply');
  const low = code.toLowerCase();
  let msg = 'err';
  let auto = false;
  try {
    const cur = await (await fetch('/cart.js', { cache: 'no-store' })).json();
    auto =
      (cur.cart_level_discount_applications || []).length > 0 ||
      (cur.items || []).some((i) => (i.line_level_discount_allocations || []).length > 0);
    const others = (cur.discount_codes || []).map((d) => d.code).filter((c) => c && c.toLowerCase() !== low);
    const data = await cartRequest('/cart/update.js', { discount: others.concat(code).join(',') });
    adoHwBusy(true);
    const hit = (data.discount_codes || []).find((d) => String(d.code).toLowerCase() === low);
    msg = hit && hit.applicable ? '' : 'na';
    if (msg) await cartRequest('/cart/update.js', { discount: others.join(',') });
  } catch (err) {}
  adoHwBusy(false);
  if (!msg) return;
  /* košík se mezitím překreslil → zprávu napíšeme do nového prvku */
  const box =
    document.querySelector('dialog[open] [data-ado-hw-cart], .adoc-page [data-ado-hw-cart]') ||
    btn.closest('[data-ado-hw-cart]');
  const m = box && box.querySelector('[data-ado-hw-msg]');
  if (m) {
    m.textContent = msg === 'na' ? box.getAttribute('data-na') + (auto ? box.getAttribute('data-na2') : '') : box.getAttribute('data-err');
    m.hidden = false;
  }
});

/* v4: kód HALLOWEEN10 platí jen na Essentials → tlačítko jen když je v košíku aspoň 1 kus Essentials. Rozhoduje Liquid
   (part 'cart', překreslí se s košíkem); pro jistotu po každé změně košíku přepočítáme i tady podle /cart.js
   (stejné pravidlo jako chytrá kolekce fear-of-god-essentials: název obsahuje „Essentials“ a „Fear of God“). */
/* v19: zase cokoli z Essentials (i set) – kód se se setovou slevou sčítá (v18 pravidlo „bez jiné slevy ≥ 10 %“ zrušeno). */
function adoHwEss(items) {
  return (items || []).some((i) => /essentials/i.test(i.product_title || '') && /fear of god/i.test(i.product_title || ''));
}
async function adoHwCartSync() {
  const boxes = document.querySelectorAll('[data-ado-hw-cart]');
  if (!boxes.length) return;
  try {
    const c = await (await fetch('/cart.js', { cache: 'no-store' })).json();
    const ok = adoHwEss(c.items);
    boxes.forEach((b) => {
      if (b.querySelector('.ado-hw-cart__ok')) return;
      b.hidden = !ok;
    });
  } catch (err) {}
}
document.addEventListener('cart:update', () => setTimeout(adoHwCartSync, 60));

/* ---------- v5 „Přidej k nákupu“ – oblečení: dvojička do setu + doporučení Shopify + kolekce Essentials ----------
   Zdroje: bundle blok produktu (set), /recommendations/products.json (complementary + related) a kolekce Essentials
   (/collections/<handle>/products.json, jen když je v košíku kus Essentials; zkrácený seznam se pamatuje v sessionStorage).
   Jen skladem (varianta available, ne „cena 99 999“), bez sad („set“), bez věcí v košíku, bez boxerek/ponožek/pojištění,
   u bot a pantoflí bez alternativ ke stejnému druhu. Vidět 5 řádků, další za „Zobrazit další“.
   v6 pořadí (Dominik: k Black hoodie chtěl Jet Black kraťasy a tričko, ne hned NBA):
     1) dvojička do setu,
     2) stejná řada (Essentials hlavní řada / NBA / 1977 / 90s) + stejná nebo velmi podobná barva z názvu
        (Black ≈ Jet Black ≈ Glossy Jet Black, Stretch Limo blízko černé; Light Oatmeal ≈ Oatmeal…),
     3) stejná řada, jiná neutrální barva (nejdřív nejbližší odstín, pak stejná sezóna S22/S24/S25),
     4) ostatní (NBA, jiné řady, výrazné barvy) – jen když první tři skupiny nenaplní seznam.
   V každé skupině se druhy střídají (kraťasy, tričko, mikina, tepláky), nejdřív druhy, které v košíku ještě nejsou.
   Prvek má data-skip-subtree-update → Horizon ho při překreslení košíku nepřepíše, jen změní data-* a my přepočítáme.
   Načítá se až po otevření košíku. */
const adoRecCache = new Map();
function adoKind(s) {
  s = String(s || '').toLowerCase();
  if (/slide|pantofl|slipper|tasman|ugg/.test(s)) return 'slides';
  if (/tenisk|sneaker|dunk|jordan|samba|campus|gazelle|air force|air max|new balance|asics|boost|foam runner/.test(s)) return 'shoes';
  if (/hoodie|mikin|crewneck|sweatshirt/.test(s)) return 'hoodie';
  if (/sweatpant|tepl|jogger|pants|kalhot|jeans|denim/.test(s)) return 'pants';
  if (/short|kraťas|šort/.test(s)) return 'shorts';
  if (/t-shirt|tee|trič|tank|longsleeve/.test(s)) return 'tee';
  if (/jacket|bund|puffer|vest/.test(s)) return 'jacket';
  if (/beanie|čepic|cap|kšilt/.test(s)) return 'cap';
  return '';
}
const ADO_COLORS = 'light dark oatmeal black limo stretch heather grey gray desert sand taupe coral iron jet white bright stone homestead timber glossy smoke vintage shell wheat yellow warm cream beige brown navy blue green olive red pink sail bone sage khaki off'.split(' ');
const ADO_SERIES = { s21: 's21', s22: 's22', ss22: 's22', s24: 's24', s25: 's25', ss25: 's25', fw22: 'fw22', fw24: 'fw24' };
/* v6: barva z názvu → základ + odstín; rodiny barev a neutrální barvy */
const ADO_MOD = new Set(['glossy', 'vintage', 'bright', 'stretch', 'warm', 'jet', 'off']);
const ADO_LIGHT = new Set(['light', 'dark']);
const ADO_FAM = {
  black: 'black', limo: 'black',
  oatmeal: 'oat', cream: 'oat', bone: 'oat', sail: 'oat', shell: 'oat', beige: 'oat',
  heather: 'grey', grey: 'grey', gray: 'grey', iron: 'grey', stone: 'grey', smoke: 'grey', homestead: 'grey',
  desert: 'sand', sand: 'sand', taupe: 'sand', timber: 'sand', wheat: 'sand', khaki: 'sand', brown: 'sand',
  white: 'white',
};
const ADO_NEUTRAL = new Set(['black', 'oat', 'grey', 'sand', 'white']);
function adoTokens(h) {
  return String(h || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
}
function adoSeries(h) {
  return adoTokens(h).map((t) => ADO_SERIES[t]).filter(Boolean);
}
/* řada: hlavní řada Essentials (S22/S24/S25/FW…, Arch Logo) vs. samostatné kolekce NBA / 1977 / 90s / Core Collection; jiné značky = 'x' */
function adoLine(t) {
  const k = adoTokens(t);
  if (!k.includes('essentials')) return 'x';
  if (k.includes('nba')) return 'nba';
  if (k.includes('1977')) return '1977';
  if (k.includes('90s')) return '90s';
  if (k.includes('core') && k.includes('collection')) return 'corecoll';
  return 'core';
}
function adoColorOf(t) {
  const k = adoTokens(t).filter((x) => ADO_COLORS.includes(x));
  const base = [...new Set(k.filter((x) => !ADO_MOD.has(x) && !ADO_LIGHT.has(x)))].sort();
  const fam = [...new Set(base.map((x) => ADO_FAM[x] || x))].sort();
  return { key: k.join('-'), base: base.join('-'), light: k.find((x) => ADO_LIGHT.has(x)) || '', fam, neutral: fam.length > 0 && fam.every((x) => ADO_NEUTRAL.has(x)) };
}
/* podobnost barev: 5 stejná, 4 stejný základ (Black ≈ Jet Black, Light Oatmeal ≈ Oatmeal), 3 stejná rodina (Black ≈ Stretch Limo),
   2 stejná rodina jiný odstín (Light × Dark Oatmeal), 1.5 dvoubarevné se společnou rodinou, 1 obě neutrální, 0 jinak */
function adoColorSim(a, b) {
  if (!a.base || !b.base) return 0;
  const lightOk = !a.light || !b.light || a.light === b.light;
  if (a.key === b.key) return 5;
  if (a.base === b.base && lightOk) return 4;
  const fa = a.fam.join('-');
  const fb = b.fam.join('-');
  if (fa === fb && a.fam.length === 1) return lightOk ? 3 : 2;
  if (a.fam.some((x) => b.fam.includes(x))) return 1.5;
  return a.neutral && b.neutral ? 1 : 0;
}
function adoImg(src, w) {
  if (!src) return '';
  const s = src.startsWith('//') ? 'https:' + src : src;
  return s + (s.includes('?') ? '&' : '?') + 'width=' + w;
}
/* jednotný tvar produktu (ceny v haléřích/centech měny košíku) */
function adoNorm(p, fromColl) {
  const cents = (x) => (x == null || x === '' ? 0 : fromColl ? Math.round(parseFloat(x) * 100) : Number(x));
  const img = fromColl ? (p.images && p.images[0] && p.images[0].src) || '' : p.featured_image || (p.images && p.images[0]) || '';
  return {
    handle: p.handle,
    title: p.title,
    type: p.product_type || p.type || '',
    img: typeof img === 'string' ? img : (img && img.src) || '',
    variants: (p.variants || []).map((v) => ({
      id: v.id,
      size: v.option1 || v.title,
      price: cents(v.price),
      cmp: cents(v.compare_at_price),
      ok: !!v.available && cents(v.price) < 9999900,
    })),
  };
}
function adoRecsFor(id) {
  if (adoRecCache.has(id)) return adoRecCache.get(id);
  const p = (async () => {
    const get = async (intent) => {
      try {
        const r = await fetch(`/recommendations/products.json?product_id=${id}&intent=${intent}&limit=10`);
        return ((await r.json()).products || []).map((x) => adoNorm(x, false));
      } catch (e) {
        return [];
      }
    };
    const [comp, rel] = await Promise.all([get('complementary'), get('related')]);
    return comp.concat(rel);
  })();
  adoRecCache.set(id, p);
  return p;
}
const adoCollCache = new Map();
function adoCollection(handle, limit = 250) {
  const ck = handle + ':' + limit;
  if (adoCollCache.has(ck)) return adoCollCache.get(ck);
  const key = 'adoColl2:' + ck + ':' + adoCur();
  const p = (async () => {
    try {
      const s = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (s && Date.now() - s.t < 30 * 60 * 1000) return s.list;
    } catch (e) {}
    let list = [];
    try {
      const r = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=${limit}`);
      list = ((await r.json()).products || [])
        .map((x) => adoNorm(x, true))
        .filter((x) => x.variants.some((v) => v.ok) && !/(^|-)set(-|$)|\bset\b/i.test(x.handle + ' ' + x.title))
        .map((x) => ({ ...x, variants: x.variants.filter((v) => v.ok) }));
    } catch (e) {}
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), list }));
    } catch (e) {}
    return list;
  })();
  adoCollCache.set(ck, p);
  return p;
}
/* v draweru počkat, až se košík otevře (zbytečně nestahovat na každé stránce) */
function adoWhenOpen(el) {
  const dlg = el.closest('dialog');
  if (!dlg || dlg.open) return Promise.resolve();
  return new Promise((res) => {
    const mo = new MutationObserver(() => {
      if (dlg.open) {
        mo.disconnect();
        res();
      }
    });
    mo.observe(dlg, { attributes: true, attributeFilter: ['open'] });
  });
}

const ADO_VISIBLE = 5;
const ADO_MAX = 12;
/* v11: Slides YS-01 v množstevní slevě Shopify (YZY Slide – množstevní sleva: 2 páry −100 Kč a 3 páry −200 Kč na každý pár,
   jen produkty yzy-ys-01-black / cream / fudge; ověřeno /cart.js: 1 390 → 2 × 1 290 → 3 × 1 190 Kč) */
const ADO_YS_DISC = /^yzy-ys-01-(black|cream|fudge)$/;
const ADO_KIDS = /(^|-)(kids|kid|infants?|baby|toddler|td|ps|gs)(-|$)/;
const adoIsSlide = (h) => /yeezy-slide|yzy-ys-01|(^|-)slides?(-|$)/.test(h || '');
const adoIsUgg = (h) => /^ugg-/.test(h || '');
/* UGG (#430): skupina _bid "ugg" + _qb – slevová funkce dá 5 % při 2 párech a 10 % při 3 párech na VŠECHNY páry ve skupině,
   cena kusu zaokrouhlená jako ve funkci (Kč a zł na celé, € na x,95) */
const ADO_UGG_QB = '2:5000000,3:10000000';
function adoNice(cents, cur) {
  if (cur === 'CZK' || cur === 'PLN') return Math.round(cents / 100) * 100;
  if (cur === 'EUR') return Math.round((Math.round(cents / 100 - 0.95) + 0.95) * 100);
  return Math.round(cents);
}
class AdoRecs extends HTMLElement {
  static get observedAttributes() {
    return ['data-ids', 'data-handles', 'data-sets', 'data-ess', 'data-gift', 'data-ch', 'data-disc'];
  }
  connectedCallback() {
    this.load();
  }
  attributeChangedCallback(n, a, b) {
    if (a !== b && this.isConnected) this.load();
  }
  giftEligible() {
    let declined = false;
    try {
      declined = sessionStorage.getItem('agb_declined') === '1';
    } catch (e) {}
    /* v11: dárek boxerek za KAŽDÉ 2 kusy Essentials – další kus dá dárek, když je kusů lichý počet (1, 3, 5…)
       a dárků v košíku není víc, než kolik jich bude po přidání (slevová funkce: floor(kusy / 2) zdarma) */
    const ess = Number(this.dataset.ess) || 0;
    const units = Number(this.dataset.gift) || 0;
    return ess % 2 === 1 && units <= Math.floor(ess / 2) && this.dataset.giftOk === '1' && !declined && !adoEu(this.dataset.currency);
  }
  /* slevy v košíku (názvy) – množstevní ceny ukazujeme jen když se se slevami v košíku opravdu sečtou */
  discOnly(re) {
    return (this.dataset.disc || '').split('|').filter(Boolean).every((t) => re.test(t));
  }
  async load() {
    const stamp = (this._stamp = (this._stamp || 0) + 1);
    await adoWhenOpen(this);
    if (stamp !== this._stamp) return;
    const d = this.dataset;
    const ids = (d.ids || '').split(',').filter(Boolean).slice(0, 3);
    const inCart = new Set((d.handles || '').split(',').filter(Boolean));
    const cartTitles = (d.titles || '').split('|').filter((t) => t.trim());
    const cartKinds = new Set(cartTitles.map(adoKind).filter(Boolean));
    /* položky košíku: handle:kusy:_qb:velikost */
    const ch = (d.ch || '').split(',').filter(Boolean).map((x) => {
      const [h, q, qb, size] = x.split(':');
      return { h, q: Number(q) || 0, qb: qb === '1', size: size || '' };
    });
    const hasSlides = ch.some((x) => adoIsSlide(x.h));
    const hasUgg = ch.some((x) => adoIsUgg(x.h));
    const ess = Number(d.ess) || 0;
    /* kotvy pro řazení = oblečení / boty v košíku (bez doplňků, dárku a pojištění) */
    const anchors = cartTitles.map((t) => ({ line: adoLine(t), col: adoColorOf(t), ser: adoSeries(t) }));
    const setItems = (d.sets || '')
      .split(';')
      .filter(Boolean)
      .slice(0, 2)
      .map((s) => {
        const [h, vid, price] = s.split('|');
        return { h, vid: Number(vid), price: Number(price) };
      });

    const recsP = Promise.all(ids.map(adoRecsFor));
    const collP = ess > 0 && d.coll ? adoCollection(d.coll) : Promise.resolve([]);
    /* v11: bestsellery obchodu (kolekce „nejprodavanejsi“ je řazená podle prodejů) – doplní každý seznam, ať není nikdy prázdný */
    const bestP = adoCollection('nejprodavanejsi', 60);
    const slideP = hasSlides ? adoCollection('yeezy-slide', 40) : Promise.resolve([]);
    const uggP = hasUgg ? adoCollection('ugg', 80) : Promise.resolve([]);
    const setsP = Promise.all(
      setItems.map(async (it) => {
        const info = await adoSetInfo(it.h);
        if (!info || info.mode !== 'dvojce' || !info.partner || inCart.has(info.partner)) return null;
        const p = await adoProduct(info.partner);
        if (!p || !p.available) return null;
        return { it, info, p: adoNorm(p, false) };
      })
    );
    const [lists, coll, best, slides, uggs] = await Promise.all([recsP, collP, bestP, slideP, uggP]);
    if (stamp !== this._stamp) return;
    const rank = new Map(best.map((p, i) => [p.handle, i]));
    const rk = (h) => (rank.has(h) ? rank.get(h) : 999);
    const minPrice = (p) => Math.min(...p.variants.filter((v) => v.ok).map((v) => v.price));
    const cartSizes = new Set(ch.map((x) => x.size).filter(Boolean));
    const hasCartSize = (p) => p.variants.some((v) => v.ok && cartSizes.has(v.size));

    const build = (sets) => {
      const seen = new Set();
      const out = [];
      const okBase = (p) =>
        p && p.handle && !seen.has(p.handle) && !inCart.has(p.handle) && !/^supreme-hanes|essential-cart-order/.test(p.handle) &&
        !/(^|-)set(-|$)|\bset\b/i.test(p.handle + ' ' + p.title) && p.variants.some((v) => v.ok);
      const push = (p, extra) => {
        seen.add(p.handle);
        out.push({ p, kind: adoKind(p.title + ' ' + p.type), ...(extra || {}) });
      };
      for (const s of sets) {
        if (!s || seen.has(s.p.handle)) continue;
        push(s.p, { set: s });
      }
      /* v11 Slides: nejdřív další Slides v nejprodávanějších barvách (u YS-01 Black/Cream/Fudge cena při 2 / 3 párech
         podle skutečné množstevní slevy, jen když se v košíku nesčítá s jinou slevou), pak levnější oblečení: tričko,
         mikina, tepláky */
      if (hasSlides) {
        const ysN = ch.filter((x) => ADO_YS_DISC.test(x.h)).reduce((a, x) => a + x.q, 0);
        const ysOk = this.discOnly(/^YZY Slide/);
        const pool = slides.filter((p) => okBase(p) && !ADO_KIDS.test(p.handle) && adoIsSlide(p.handle));
        pool.sort((a, b) => (hasCartSize(b) ? 1 : 0) - (hasCartSize(a) ? 1 : 0) || rk(a.handle) - rk(b.handle));
        for (const p of pool.slice(0, 2)) {
          const deal = ysN >= 1 && ysOk && !adoEu(this.dataset.currency) && ADO_YS_DISC.test(p.handle) ? { kind: 'ys', n: Math.min(ysN + 1, 3) } : null;
          push(p, { deal });
        }
        const clothes = best.filter((p) => okBase(p) && ['tee', 'hoodie', 'pants'].includes(adoKind(p.title + ' ' + p.type)));
        for (const k of ['tee', 'hoodie', 'pants']) {
          const c = clothes.filter((p) => !seen.has(p.handle) && adoKind(p.title + ' ' + p.type) === k).sort((a, b) => rk(a.handle) - rk(b.handle))[0];
          if (c) push(c);
        }
      }
      /* v11 UGG: nejdřív další UGG (kolekce UGG je ručně řazená – bestsellery první) se slevou 5 % / 10 % při 2 / 3 párech,
         když položka UGG v košíku nese skupinu slevy (_qb) a v košíku není jiná sleva; pak ostatní */
      if (hasUgg) {
        const uN = ch.filter((x) => adoIsUgg(x.h)).reduce((a, x) => a + x.q, 0);
        const qbOk = !adoEu(this.dataset.currency) && ch.some((x) => adoIsUgg(x.h) && x.qb) && this.discOnly(/adonio|bundle/i);
        const pool = uggs.filter((p) => okBase(p) && !ADO_KIDS.test(p.handle) && adoIsUgg(p.handle));
        pool.sort((a, b) => (hasCartSize(b) ? 1 : 0) - (hasCartSize(a) ? 1 : 0));
        for (const p of pool.slice(0, 3)) push(p, { deal: qbOk ? { kind: 'ugg', n: Math.min(uN + 1, 3) } : null, props: qbOk ? { _bid: 'ugg', _qb: ADO_UGG_QB } : null });
      }
      const cands = [];
      const take = (p, src) => {
        if (!okBase(p)) return;
        /* Slides a UGG poznat i podle handle (např. „YZY YS-01 Chocolate“ nemá v názvu „slide“) */
        const kind = adoIsSlide(p.handle) || adoIsUgg(p.handle) ? 'slides' : adoKind(p.title + ' ' + p.type);
        /* boty a pantofle: žádná alternativa ke stejnému druhu (Slides a UGG mají vlastní blok výše) */
        if ((kind === 'shoes' || kind === 'slides') && cartKinds.has(kind)) return;
        if (ADO_KIDS.test(p.handle)) return;
        seen.add(p.handle);
        const line = adoLine(p.title);
        const col = adoColorOf(p.title);
        const ser = adoSeries(p.title);
        let bst = { tier: 4, sim: -1, ser: 0 };
        for (const a of anchors.length ? anchors : [{ line: 'x', col: adoColorOf(''), ser: [] }]) {
          const sim = adoColorSim(col, a.col);
          const same = a.line === line;
          const tier = same && sim >= 3 ? 2 : same && col.neutral ? 3 : 4;
          const sm = ser.some((x) => a.ser.includes(x)) ? 1 : 0;
          if (tier < bst.tier || (tier === bst.tier && (sim > bst.sim || (sim === bst.sim && sm > bst.ser)))) bst = { tier, sim, ser: sm };
        }
        cands.push({ p, kind, tier: bst.tier, sim: bst.sim, ser: bst.ser, rec: src === 'rec' ? 1 : 0, src, i: cands.length });
      };
      for (const list of lists) for (const p of list) take(p, 'rec');
      if (ess > 0) for (const p of coll) take(p, 'coll');
      for (const p of best) take(p, 'best');
      const covered = new Set(cartKinds);
      for (const o of out) if (o.kind) covered.add(o.kind);
      const byScore = (a, b) => b.sim - a.sim || b.ser - a.ser || b.rec - a.rec || a.i - b.i;
      const roundRobin = (list, cmpRound) => {
        const groups = new Map();
        for (const c of list) {
          const k = c.kind || 'x';
          if (!groups.has(k)) groups.set(k, []);
          groups.get(k).push(c);
        }
        while (out.length < ADO_MAX && [...groups.values()].some((g) => g.length)) {
          const round = [...groups.values()].filter((g) => g.length).map((g) => g.shift());
          round.sort(cmpRound);
          for (const c of round) {
            if (out.length < ADO_MAX) out.push(c);
            if (c.kind) covered.add(c.kind);
          }
        }
      };
      if (ess > 0) {
        /* Essentials (v6 beze změny): set → stejná řada + stejná / podobná barva → stejná řada jiná neutrální → ostatní;
           v každé skupině se druhy střídají, nejdřív druhy, které v košíku nejsou */
        for (const tier of [2, 3, 4]) {
          if (out.length >= ADO_MAX) break;
          const list = cands.filter((c) => c.tier === tier && c.src !== 'best').sort(byScore);
          roundRobin(list, (a, b) => (covered.has(a.kind) ? 1 : 0) - (covered.has(b.kind) ? 1 : 0) || byScore(a, b));
        }
      }
      /* v11: zbytek (a u košíku bez Essentials celý seznam) = doporučení Shopify + bestsellery obchodu jako pestrý mix
         druhů (tričko, kraťasy, mikina, tepláky, Slides…): v každém kole nejprodávanější kus každého druhu (doporučení
         Shopify, která nejsou mezi bestsellery, za nimi), kolo seřazené od nejlevnějšího */
      const pr = (c) => (rank.has(c.p.handle) ? rank.get(c.p.handle) : 500 + c.i);
      const rest = cands.filter((c) => !out.includes(c) && (ess === 0 || c.src === 'best')).sort((a, b) => pr(a) - pr(b));
      roundRobin(rest, (a, b) => minPrice(a.p) - minPrice(b.p));
      return out;
    };
    /* set počkat chvíli (údaje bývají už z produktové stránky), ať řádky neposkakují; jinak doplnit později */
    const quick = await Promise.race([setsP, new Promise((r) => setTimeout(() => r(null), 2500))]);
    if (stamp !== this._stamp) return;
    this.render(build(quick || []));
    if (!quick) {
      const sets = await setsP;
      if (stamp !== this._stamp) return;
      if (sets.some(Boolean)) this.render(build(sets));
    }
  }
  /* předvyplněná velikost: stejná jako v košíku (data-pref = velikost oblečení z košíku), jinak nejčastější M → L → S … */
  prefVariant(vs) {
    const ok = vs.filter((v) => v.ok);
    const sizes = (this.dataset.sizes || '').split('|').filter(Boolean);
    const order = [this.dataset.pref, ...sizes, 'M', 'L', 'S', 'XL', 'XS', 'XXL', 'XXS'].filter(Boolean);
    for (const s of order) {
      const v = ok.find((x) => x.size === s);
      if (v) return v;
    }
    return ok[0];
  }
  render(picks) {
    const d = this.dataset;
    const cur = d.currency;
    const loc = d.locale;
    const gift = this.giftEligible();
    const M = (x) => adoMoney(x, cur, loc);
    this.dataset.order = picks.map((x) => x.p.handle).join(',');
    /* v7 (#620, ZMĚNA 3): dárek boxerek = nízký rámeček v informačním sloupci pod cenou (začíná jako název a velikost) – fotka 28 px, „+ Supreme boxerky“, vpravo přeškrtnutá cena a ZDARMA */
    const giftBox = gift
      ? `<div class="adoc-giftbox">${d.giftImg ? `<img src="${adoEsc(d.giftImg)}" alt="" width="28" height="28" loading="lazy">` : ''}<span class="adoc-giftbox__tx">${adoEsc(d.tGiftName)}</span><span class="adoc-giftbox__pr">${Number(d.giftPrice) > 0 ? `<s>${adoEsc(M(d.giftPrice))}</s>` : ''}<em>${adoEsc(d.tFree)}</em></span></div>`
      : '';
    const rows = picks.map(({ p, set, deal, props }, i) => {
      const okv = p.variants.filter((v) => v.ok);
      const url = `/products/${adoEsc(p.handle)}`;
      const single = p.variants.length === 1 && /default/i.test(p.variants[0].size || '');
      const showGift = gift && /essentials/i.test(p.handle);
      const calc = (v) => {
        if (set) return { now: adoSetPrice(v.price, Number(set.info.bp2), cur), strike: v.price };
        if (deal && deal.kind === 'ys' && deal.n >= 2) {
          const off = adoConv(deal.n >= 3 ? 20000 : 10000, cur);
          if (off != null) return { now: v.price - off, strike: v.price };
        }
        if (deal && deal.kind === 'ugg' && deal.n >= 2) return { now: adoNice(v.price * (deal.n >= 3 ? 0.9 : 0.95), cur), strike: v.price };
        return { now: v.price, strike: v.cmp > v.price ? v.cmp : 0 };
      };
      const v0 = this.prefVariant(p.variants) || okv[0];
      const c0 = calc(v0);
      const attrs = set
        ? `data-adoc-kind="set" data-main-vid="${set.it.vid}" data-bp-main="${adoEsc(set.info.bp1)}" data-bp-partner="${adoEsc(set.info.bp2)}"`
        : `data-adoc-kind="rec"${props ? ` data-adoc-props='${adoEsc(JSON.stringify(props))}'` : ''}`;
      const dealOn = deal && deal.n >= 2 && c0.now < c0.strike;
      const lbl = set ? d.tSet : dealOn ? (deal.n >= 3 ? d.tPair3 : d.tPair2) : '';
      const badge = dealOn && deal.kind === 'ugg' ? `<span class="adoc-sale">${adoEsc(d.tSale)} ${deal.n >= 3 ? 10 : 5} %</span>` : '';
      const opts = okv
        .map((v) => {
          const c = calc(v);
          return `<option value="${v.id}" data-p="${adoEsc(M(c.now))}"${c.strike ? ` data-s="${adoEsc(M(c.strike))}"` : ''}${v.id === v0.id ? ' selected' : ''}>${adoEsc(v.size)}</option>`;
        })
        .join('');
      return `<div class="adoc-row adoc-row--rec${set ? ' adoc-row--set' : ''}${dealOn ? ' adoc-row--deal' : ''}${showGift ? ' has-gift' : ''}${i >= ADO_VISIBLE && picks.length > ADO_VISIBLE + 1 ? ' is-more' : ''}" data-adoc-card ${attrs} data-handle="${adoEsc(p.handle)}">
          <a class="adoc-row__img" href="${url}" tabindex="-1">${p.img ? `<img src="${adoEsc(adoImg(p.img, 160))}" alt="" width="60" height="60" loading="lazy">` : ''}</a>
          <div class="adoc-row__info">
            <a class="adoc-row__title" href="${url}">${adoEsc(p.title)}</a>
            <div class="adoc-row__price">${lbl ? `<span class="adoc-row__pl">${adoEsc(lbl)}</span>` : ''}<span class="adoc-red" data-adoc-cprice>${M(c0.now)}</span><s data-adoc-cstrike${c0.strike ? '' : ' hidden'}>${c0.strike ? M(c0.strike) : ''}</s>${badge}</div>
            ${showGift ? giftBox : ''}
          </div>
          <div class="adoc-row__ctl">
            <select class="adoc-var adoc-row__size${single ? ' is-one' : ''}" data-adoc-psize aria-label="${adoEsc(d.tSize)}"${single ? ' hidden' : ''}>${opts}</select>
            <button type="button" class="adoc-row__add" data-adoc-add data-adoc-label="${adoEsc(d.tAdd)}" data-adoc-busy="${adoEsc(d.tAdding)}" data-adoc-done="${adoEsc(d.tAdded)}">${adoEsc(d.tAdd)}</button>
          </div>
        </div>`;
    });
    const hidden = picks.length > ADO_VISIBLE + 1 ? picks.length - ADO_VISIBLE : 0;
    this.innerHTML =
      rows.join('') +
      (hidden
        ? `<button type="button" class="adoc-more" data-adoc-more>${adoEsc(d.tMore)} (${hidden})${adoIcon('chev')}</button>`
        : '');
  }
}
if (!customElements.get('ado-recs')) customElements.define('ado-recs', AdoRecs);

/* nabídka „ještě 1 kus ESSENTIALS“ – když zákazník dárek odmítl (agb-gift.js), už neslibovat */
let adoUiQueued = false;
function adoUiSoon() {
  if (adoUiQueued) return;
  adoUiQueued = true;
  requestAnimationFrame(() => {
    adoUiQueued = false;
    let declined = false;
    try {
      declined = sessionStorage.getItem('agb_declined') === '1';
    } catch (e) {}
    if (declined) document.querySelectorAll('[data-adoc-ess-offer]').forEach((e) => (e.hidden = true));
    /* v11: nové karty Supreme (po překreslení košíku) – ceny za kusy, poznámka „2 ks za …“ */
    document.querySelectorAll('[data-adoc-qp]:not([data-qp-ready])').forEach(adoQpRender);
  });
}
new MutationObserver(adoUiSoon).observe(document.documentElement, { childList: true, subtree: true });
adoUiSoon();

/* ---------- v7 (#620, varianta 2): doručení u každé položky košíku ----------
   Stejný výpočet jako produktová stránka (blok zpráv u varianty): datum = dnes + dny kalendářních dnů + 1 pracovní den,
   dny = metafield varianty custom.dny_na_odeslani (prázdné → 6, „set“ s 1 variantou → 1).
   dny ≤ 2 → „Můžeme doručit do: po 26. 10.“, dny ≥ 3 → „Můžeme doručit mezi: út 27. 10. – po 2. 11.“ (začátek = dnes + 2 pracovní dny).
   Počítá se v prohlížeči (stránka se cachuje); vyplní se po každém překreslení košíku (MutationObserver výše). */
function adoAddBiz(start, n) {
  const d = new Date(start);
  let added = 0;
  while (added < n) {
    d.setDate(d.getDate() + 1);
    const w = d.getDay();
    if (w !== 0 && w !== 6) added++;
  }
  return d;
}
const ADO_WD = {
  cs: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
  sk: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
  pl: ['nd', 'pn', 'wt', 'śr', 'cz', 'pt', 'sb'],
  ro: ['dum', 'lun', 'mar', 'mie', 'joi', 'vin', 'sâm'],
  hu: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
};
function adoFmtDay(d, l) {
  const wd = (ADO_WD[l] || ADO_WD.cs)[d.getDay()];
  if (l === 'ro') return `${wd} ${d.getDate()}.${d.getMonth() + 1}`;
  if (l === 'hu') return `${d.getMonth() + 1}. ${d.getDate()}., ${wd}`;
  return l === 'en' ? `${wd} ${d.getDate()}/${d.getMonth() + 1}` : `${wd} ${d.getDate()}. ${d.getMonth() + 1}.`;
}
function adoDelivFill(root) {
  (root || document).querySelectorAll('.adoc-deliv[data-t1]').forEach((el) => {
    const raw = el.dataset.dny;
    const dny = el.dataset.set === '1' ? 1 : raw != null && raw !== '' ? Number(raw) : 6;
    if (!Number.isFinite(dny)) return;
    const today = new Date();
    const plus = new Date(today);
    plus.setDate(plus.getDate() + dny);
    const end = adoAddBiz(plus, 1);
    const start = adoAddBiz(today, 2);
    const l = (el.dataset.l || 'cs').slice(0, 2);
    const range = dny >= 3 && start < end;
    /* v11: datum je klepací (vysvětlení jako na produktu – adoTipShow) */
    const dAttr = el.dataset.tip ? ' class="adoc-deliv__d" role="button" tabindex="0" aria-expanded="false" aria-controls="adoc-tip"' : '';
    const html = range
      ? `${adoEsc(el.dataset.t2)} <span${dAttr}>${adoFmtDay(start, l)} – ${adoFmtDay(end, l)}</span>`
      : `${adoEsc(el.dataset.t1)} <span${dAttr}>${adoFmtDay(end, l)}</span>`;
    const key = `${dny}|${end.toDateString()}`;
    if (el.dataset.k === key) return;
    el.dataset.k = key;
    el.dataset.end = `${end.getDate()}.${end.getMonth() + 1}.${end.getFullYear()}`;
    el.dataset.mode = range ? 'mezi' : 'do';
    el.innerHTML = html;
  });
}
/* ---------- v11: vysvětlení data doručení (jako na produktu) ----------
   Na produktu se po najetí / klepnutí na datum ukáže tmavé okénko „Doba doručení se může lišit podle vytíženosti
   dopravce.“ (na telefonu uprostřed obrazovky). V košíku stejný text a vzhled: klepnutí na datum okénko ukáže,
   další klepnutí kamkoli ho zavře; na počítači i po najetí myší. */
let adoTipEl = null;
let adoTipFor = null;
function adoTipHide() {
  if (adoTipEl) adoTipEl.hidden = true;
  if (adoTipFor) adoTipFor.setAttribute('aria-expanded', 'false');
  adoTipFor = null;
}
function adoTipShow(dEl) {
  const host = dEl.closest('dialog') || document.body;
  if (!adoTipEl || adoTipEl.parentNode !== host) {
    if (adoTipEl) adoTipEl.remove();
    adoTipEl = document.createElement('div');
    adoTipEl.className = 'adoc-tip';
    adoTipEl.id = 'adoc-tip';
    adoTipEl.setAttribute('role', 'tooltip');
    host.appendChild(adoTipEl);
  }
  const wrap = dEl.closest('.adoc-deliv');
  adoTipEl.textContent = (wrap && wrap.dataset.tip) || '';
  adoTipEl.hidden = false;
  adoTipFor = dEl;
  dEl.setAttribute('aria-expanded', 'true');
  const r = dEl.getBoundingClientRect();
  const W = window.innerWidth;
  const H = window.innerHeight;
  const tw = adoTipEl.offsetWidth;
  const th = adoTipEl.offsetHeight;
  let x;
  let y;
  if (W < 750) {
    x = (W - tw) / 2;
    y = (H - th) / 2;
  } else {
    x = Math.min(Math.max(8, r.left + r.width / 2 - tw / 2), W - tw - 8);
    y = r.top - th - 10;
    if (y < 8) y = r.bottom + 10;
  }
  adoTipEl.style.left = x + 'px';
  adoTipEl.style.top = y + 'px';
  /* v dialogu s transformací se „fixed“ počítá od dialogu – dorovnat na skutečnou polohu */
  const rr = adoTipEl.getBoundingClientRect();
  adoTipEl.style.left = x - (rr.left - x) + 'px';
  adoTipEl.style.top = y - (rr.top - y) + 'px';
}
document.addEventListener('click', (e) => {
  const t = e.target instanceof Element ? e.target : null;
  const dEl = t && t.closest('.adoc-deliv__d');
  if (dEl) {
    e.preventDefault();
    if (adoTipFor === dEl && adoTipEl && !adoTipEl.hidden) adoTipHide();
    else adoTipShow(dEl);
    return;
  }
  if (adoTipFor) adoTipHide();
});
document.addEventListener('keydown', (e) => {
  const dEl = e.target instanceof Element ? e.target.closest('.adoc-deliv__d') : null;
  if (dEl && (e.key === 'Enter' || e.key === ' ')) {
    e.preventDefault();
    adoTipShow(dEl);
  } else if (e.key === 'Escape' && adoTipFor) adoTipHide();
});
document.addEventListener('mouseover', (e) => {
  if (!window.matchMedia || !matchMedia('(hover: hover)').matches) return;
  const dEl = e.target instanceof Element ? e.target.closest('.adoc-deliv__d') : null;
  if (dEl && adoTipFor !== dEl) adoTipShow(dEl);
});
document.addEventListener('mouseout', (e) => {
  if (!window.matchMedia || !matchMedia('(hover: hover)').matches) return;
  const dEl = e.target instanceof Element ? e.target.closest('.adoc-deliv__d') : null;
  if (dEl && adoTipFor === dEl) adoTipHide();
});
document.addEventListener('scroll', () => adoTipFor && adoTipHide(), true);

let adoDelivQueued = false;
new MutationObserver(() => {
  if (adoDelivQueued) return;
  adoDelivQueued = true;
  requestAnimationFrame(() => {
    adoDelivQueued = false;
    adoDelivFill();
  });
}).observe(document.documentElement, { childList: true, subtree: true });
adoDelivFill();

/* ---------- v11: hlídání košíku po každé změně ----------
   1) Pojištění zásilky (essential-cart-order-upsell-default) samotné v košíku nedává smysl – když po odebrání zboží
      zůstane jen ono, odebere se (drawer i stránka /cart, i při mazání tlačítkem koše).
   2) Dárek boxerek za KAŽDÉ 2 kusy Essentials: slevová funkce dává zdarma floor(kusy / 2) kusů s _gift (ověřeno /cart.js)
      a sety ado-2sety přidávají 2 dárky, ale agb-gift.js přidá jen první. Košík proto doplní další dárek (stejná barva
      a velikost jako první, vlastní řádek s _g, ať jde barva i velikost změnit zvlášť). Když zákazník doplněný dárek
      odebere, znovu se nepřidá (dokud kusů neubude pod 4); když dárek odmítl úplně (agb_declined), nic se nepřidává.
      Když kusů ubude, doplněné dárky navíc se odeberou. */
const ADO_INS = 'essential-cart-order-upsell-default';
const ADO_BOX = /^supreme-hanes-boxer-briefs-(white|black)$/;
function adoSs(k, v) {
  try {
    if (v === undefined) return sessionStorage.getItem(k);
    sessionStorage.setItem(k, String(v));
  } catch (e) {}
  return null;
}
async function adoGiftTopUp(cart) {
  const items = cart.items || [];
  const isGift = (i) => i.properties && i.properties._gift && ADO_BOX.test(i.handle);
  const ess = items.filter((i) => !(i.properties && i.properties._gift) && /essentials/i.test(i.handle)).reduce((a, i) => a + i.quantity, 0);
  const gifts = items.filter(isGift);
  const units = gifts.reduce((a, i) => a + i.quantity, 0);
  const want = Math.floor(ess / 2);
  if (want < 2) adoSs('adoc_gnod', '0');
  if (units > want) {
    let over = units - want;
    /* v11.1: odebírat i dárky přidané jinou cestou (nabídka v košíku, agb-gift) – jinak zůstane dárek navíc za plnou cenu.
       Nejdřív doplněné (_g), pak ostatní od nejnovějšího; vždy zůstane floor(kusy/2) dárků. */
    const cand = [...gifts.filter((g) => g.properties._g).reverse(), ...gifts.filter((g) => !g.properties._g)];
    for (const i of cand) {
      if (over <= 0) break;
      const n = Math.min(i.quantity, over);
      await cartRequest('/cart/change.js', { id: i.key, quantity: i.quantity - n });
      over -= n;
    }
    adoSs('adoc_gifts', want);
    return;
  }
  const declined = adoSs('agb_declined') === '1';
  if (declined || units < 1 || units >= want) {
    adoSs('adoc_gifts', units);
    return;
  }
  const seen = Number(adoSs('adoc_gifts') || 0);
  if (seen > units && seen <= want) adoSs('adoc_gnod', '1');
  if (adoSs('adoc_gnod') === '1') {
    adoSs('adoc_gifts', units);
    return;
  }
  const base = gifts[0];
  const add = [];
  for (let k = units + 1; k <= want; k++) add.push({ id: base.variant_id, quantity: 1, properties: { _gift: '1', _auto: '1', _g: String(k) } });
  try {
    await cartRequest('/cart/add.js', { items: add });
    adoSs('adoc_gifts', want);
  } catch (e) {
    adoSs('adoc_gifts', units);
  }
}
let adoWatchT = null;
let adoWatchBusy = false;
function adoWatchSoon(ms) {
  clearTimeout(adoWatchT);
  adoWatchT = setTimeout(adoWatch, ms || 700);
}
async function adoWatch() {
  if (adoWatchBusy) return adoWatchSoon(900);
  adoWatchBusy = true;
  try {
    const cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
    const items = cart.items || [];
    if (items.length && items.every((i) => i.handle === ADO_INS)) {
      for (const i of items) await cartRequest('/cart/change.js', { id: i.key, quantity: 0 });
    } else if (items.length) {
      await adoGiftTopUp(cart);
    }
  } catch (e) {}
  adoWatchBusy = false;
}
document.addEventListener('cart:update', () => adoWatchSoon());
/* po načtení stránky jen když to vykreslený košík naznačuje (pojištění v košíku, nebo ≥ 4 kusy Essentials s méně dárky) –
   ať se na každé stránce zbytečně nestahuje /cart.js */
function adoWatchOnLoad() {
  const ins = document.querySelector('[data-adoc-ins][data-adoc-key]:not([data-adoc-key=""])');
  const r = document.querySelector('ado-recs[data-ess]');
  const ess = r ? Number(r.dataset.ess) || 0 : 0;
  const gifts = r ? Number(r.dataset.gift) || 0 : 0;
  /* v11.1: i když je dárků víc, než odpovídá kusům (kus ubyl jinak než tlačítkem) – dárek navíc by stál plnou cenu */
  if (ins || (ess >= 4 && gifts < Math.floor(ess / 2)) || (gifts > 0 && gifts > Math.floor(ess / 2))) adoWatchSoon(1500);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', adoWatchOnLoad);
else adoWatchOnLoad();

/* ---------- v14 (Dominik 25. 10. 2026): okno „Speciální akce“ HNED PO PŘIDÁNÍ DO KOŠÍKU ----------
   „chci to po kliknutí přidat do košíku a až když člověk zavře nebo přidá tak se zobrazí ten košík“.
   Zboží se přidá normálně, ale místo šuplíku košíku se ukáže okno se Supreme trenkami / ponožkami (barva, velikost).
   Šuplík se otevře až po zavření okna (křížek, klepnutí mimo, Esc, „Ne, díky“) nebo po přidání doplňku – s aktuálním
   obsahem. Platí pro všechno, co po přidání otevírá šuplík (formulář produktu, rychlé přidání, setové bloky…):
   1) fetch na /cart/add se zachytí (jen když šuplík ani okno nejsou otevřené, nejsme na /cart a okno se v této návštěvě
      ještě neukázalo; dárky _gift ne) → z čerstvě vykreslené sekce šuplíku (sekce z odpovědi /cart/add, jinak se
      stáhnou) se vezmou data script[data-adoc-pre] – snippets/ado-cart.liquid je vykreslí jen v košíku BEZ zaplacených
      Supreme trenek a ponožek (dárek _gift se nepočítá), takže přidání samotných trenek/ponožek okno neukáže;
   2) showDialog šuplíku (auto-open po CartAddEvent i drawer.open() ze setových bloků) se podrží, dokud není jasné,
      jestli okno ukázat (nejdéle 3 s) → buď okno, nebo hned šuplík. Žádné probliknutí šuplíku pod oknem.
   Jen se zbožím skladem. Před pokladnou se od v14 nic neukazuje. Okno je <dialog> přímo v <body>.
   v15 (Dominik 25. 10.): „ať je to maximálně jednou za den na návštěvníka“ → localStorage adoc_pre_t = { t: čas zobrazení,
   add: přidal doplněk }: okno nejvýš 1× za 24 h na prohlížeč; když zákazník z okna doplněk přidal, 7 dní ne (už ho má).
   Když se okno neukáže, šuplík se otevře hned (o okně se pak vůbec nerozhoduje, fetch se nezachytí).
   Výběr počtu 1–4 ks jako karta Supreme v košíku: stejné ceny (adoConv + tiers, jen když tok = sleva se v košíku uplatní,
   jinak počet × cena kusu), přeškrtnutá plná cena, předvoleno 2 ks se slevou, jinak 1 ks; počty nad skladem zašedlé. */
const ADO_PRE_LS = 'adoc_pre_t';
const ADO_PRE_DAY = 24 * 3600 * 1000;
const ADO_PRE_WEEK = 7 * ADO_PRE_DAY;
function adoPreBlocked() {
  try {
    const j = JSON.parse(localStorage.getItem(ADO_PRE_LS) || 'null');
    if (!j || !j.t) return false;
    const age = Date.now() - Number(j.t);
    return age >= 0 && age < (j.add ? ADO_PRE_WEEK : ADO_PRE_DAY);
  } catch (e) {
    return false;
  }
}
function adoPreMark(add) {
  try {
    localStorage.setItem(ADO_PRE_LS, JSON.stringify({ t: Date.now(), add: !!add }));
  } catch (e) {}
}
let adoPreDlg = null;
let adoPreState = null;
let adoPreWait = null; /* { p: Promise<data|null>, t } – rozhodnutí po posledním přidání */
let adoPreHold = false; /* šuplík čeká na rozhodnutí */
let adoPreAfter = null; /* otevřít šuplík po zavření okna */
const ADO_PRE_X = '<svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="m5 5 10 10M15 5 5 15"/></svg>';
const ADO_PRE_OK = '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m4.5 10.5 3.5 3.5 7.5-8"/></svg>';

function adoPreIsOpen() {
  return !!(adoPreDlg && adoPreDlg.open);
}
function adoPreKind() {
  const s = adoPreState;
  return s.d.k.find((k) => k.k === s.kind);
}
function adoPreColor(k, c) {
  return k.c.find((x) => x.c === c);
}
/* předvybraná velikost: velikost z košíku (pref), jinak M → L → S → XL → XXL, jinak první dostupná */
function adoPrePickSize(col, pref) {
  const av = col.v.filter((v) => v.av);
  for (const t of [pref, 'M', 'L', 'S', 'XL', 'XXL']) {
    const v = av.find((x) => x.t === t);
    if (v) return v.id;
  }
  return av.length ? av[0].id : null;
}
/* cena q kusů – stejně jako adoQpPrice v košíku */
function adoPrePrice(d, k, col, q) {
  const full = col.p * q;
  if (k.tok !== 1) return { now: full, full };
  const dsc = adoConv(Number(d.tiers[q - 1]) || 0, d.cur);
  if (dsc == null) return { now: full, full };
  return { now: full - dsc, full };
}
function adoPreRender() {
  const s = adoPreState;
  const d = s.d;
  const T = d.t;
  const M = (x) => adoMoney(x, d.cur, d.loc);
  const k = adoPreKind();
  let col = adoPreColor(k, s.color[k.k]);
  if (!col || !col.av) col = k.c.find((x) => x.av);
  s.color[k.k] = col.c;
  if (!col.v.some((v) => v.id === s.vid[k.k] && v.av)) s.vid[k.k] = adoPrePickSize(col, d.pref);
  const pct = col.cmp > col.p ? Math.floor(((col.cmp - col.p) * 100) / col.cmp) : 0;
  /* počet: sklad vybrané varianty (jen když se sleduje) omezí nabídku */
  const cv = col.v.find((v) => v.id === s.vid[k.k]);
  const inv = cv && cv.inv != null ? Number(cv.inv) : null;
  if (inv != null && inv > 0 && s.q > inv) s.q = inv;
  const qs = [1, 2, 3, 4]
    .map((n) => {
      const pr = adoPrePrice(d, k, col, n);
      const off = inv != null && n > inv;
      return `<button type="button" class="adoc-qp__q${n === s.q ? ' is-on' : ''}" data-adoc-pre-q="${n}" role="radio" aria-checked="${n === s.q}"${off ? ' disabled' : ''}><b>${n} ${adoEsc(T.pcs || 'ks')}</b><span>${M(pr.now)}</span>${pr.now < pr.full ? `<s>${M(pr.full)}</s>` : ''}</button>`;
    })
    .join('');
  const tot = adoPrePrice(d, k, col, s.q).now;
  const kinds = d.k
    .map((x) => {
      const xc = adoPreColor(x, s.color[x.k]) || x.c.find((y) => y.av);
      const on = x.k === k.k;
      return `<button type="button" class="adoc-pre__kind${on ? ' is-on' : ''}" data-adoc-pre-kind="${x.k}" role="radio" aria-checked="${on}">
        <span class="adoc-pre__img">${xc.img ? `<img src="${adoEsc(xc.img)}" alt="" width="48" height="48">` : ''}</span>
        <span class="adoc-pre__kl">${adoEsc(x.l)}</span>
      </button>`;
    })
    .join('');
  const colors = k.c
    .map((x) => `<button type="button" class="adoc-chip${x.c === col.c ? ' is-on' : ''}" data-adoc-pre-color="${x.c}" role="radio" aria-checked="${x.c === col.c}"${x.av ? '' : ' disabled'}>${adoEsc(x.c === 'b' ? T.b : T.w)}</button>`)
    .join('');
  const one = col.v.length === 1;
  const sizes = col.v
    .map((v) => `<button type="button" class="adoc-chip${v.id === s.vid[k.k] ? ' is-on' : ''}" data-adoc-pre-sz="${v.id}" role="radio" aria-checked="${v.id === s.vid[k.k]}"${v.av ? '' : ' disabled'}>${adoEsc(String(v.t).replace(/(\d)-(\d)/, '$1–$2'))}</button>`)
    .join('');
  /* nadpis „za zvýhodněnou cenu“ jen když má doplněk opravdu nižší cenu než původní (přeškrtnutá cena produktu) */
  const head = pct ? T.h : T.h0 || T.h;
  s.box.innerHTML = `
    <div class="adoc-pre__top">
      ${T.ok ? `<p class="adoc-pre__ok" role="status">${ADO_PRE_OK}<span>${adoEsc(T.ok)}</span></p>` : ''}
      <button type="button" class="adoc-pre__x" data-adoc-pre-x aria-label="${adoEsc(T.x)}">${ADO_PRE_X}</button>
    </div>
    ${T.tag ? `<span class="adoc-pre__tag">${adoEsc(T.tag)}</span>` : ''}
    <h2 class="adoc-pre__h" id="adoc-pre-h">${adoEsc(head)}</h2>
    <div class="adoc-pre__kinds${d.k.length > 1 ? '' : ' adoc-pre__kinds--one'}" role="radiogroup" aria-label="${adoEsc(head)}">${kinds}</div>
    <div class="adoc-pre__info">
      <p class="adoc-pre__n">${adoEsc(k.n)} ${col.c === 'b' ? 'Black' : 'White'}</p>
      <p class="adoc-pre__p"><span class="adoc-red">${M(col.p)}</span>${col.cmp > col.p ? `<s>${M(col.cmp)}</s>` : ''}${pct ? `<span class="adoc-sale">${adoEsc(T.sale)} ${pct} %</span>` : ''}</p>
    </div>
    <div class="adoc-pre__l">${adoEsc(T.color)}</div>
    <div class="adoc-pre__opts" role="radiogroup" aria-label="${adoEsc(T.color)}">${colors}</div>
    <div class="adoc-pre__l">${adoEsc(T.size)}${one ? ` <span>${adoEsc(T.one)}</span>` : ''}</div>
    <div class="adoc-pre__opts" role="radiogroup" aria-label="${adoEsc(T.size)}">${sizes}</div>
    <div class="adoc-pre__l">${adoEsc(T.qty || '')}</div>
    <div class="adoc-qp__qs" role="radiogroup" aria-label="${adoEsc(T.qty || '')}">${qs}</div>
    <button type="button" class="adoc-pre__add" data-adoc-pre-add${s.vid[k.k] ? '' : ' disabled'}>${adoEsc(T.add)} · ${s.q} ${adoEsc(T.pcs || 'ks')} · ${M(tot)}</button>
    <button type="button" class="adoc-pre__no" data-adoc-pre-no>${adoEsc(T.no)}</button>`;
}
function adoPreClose() {
  if (adoPreDlg && adoPreDlg.open) adoPreDlg.close();
}
function adoPreEnsure() {
  if (adoPreDlg && adoPreDlg.isConnected) return adoPreDlg;
  const dlg = document.createElement('dialog');
  dlg.className = 'adoc-pre';
  dlg.setAttribute('aria-labelledby', 'adoc-pre-h');
  dlg.innerHTML = '<div class="adoc-pre__box" data-adoc-pre-box></div>';
  document.body.appendChild(dlg);
  /* jakékoli zavření okna (křížek, mimo okno, Esc, „Ne, díky“, po přidání) → otevřít šuplík košíku */
  dlg.addEventListener('close', () => {
    adoPreState = null;
    const go = adoPreAfter;
    adoPreAfter = null;
    if (go) go();
  });
  dlg.addEventListener('click', async (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    /* klepnutí mimo okno (na pozadí) = zavřít */
    if (t === dlg) return adoPreClose();
    const s = adoPreState;
    if (!s || s.busy) return;
    if (t.closest('[data-adoc-pre-x]') || t.closest('[data-adoc-pre-no]')) return adoPreClose();
    const kb = t.closest('[data-adoc-pre-kind]');
    if (kb) {
      s.kind = kb.getAttribute('data-adoc-pre-kind');
      return adoPreRender();
    }
    const qb = t.closest('[data-adoc-pre-q]');
    if (qb && !qb.disabled) {
      s.q = Number(qb.getAttribute('data-adoc-pre-q')) || 1;
      return adoPreRender();
    }
    const cb = t.closest('[data-adoc-pre-color]');
    if (cb && !cb.disabled) {
      const k = adoPreKind();
      const old = adoPreColor(k, s.color[k.k]);
      const oldT = old && (old.v.find((v) => v.id === s.vid[k.k]) || {}).t;
      s.color[k.k] = cb.getAttribute('data-adoc-pre-color');
      /* při změně barvy zůstane stejná velikost, je-li skladem */
      const nc = adoPreColor(k, s.color[k.k]);
      const same = nc && nc.v.find((v) => v.t === oldT && v.av);
      s.vid[k.k] = same ? same.id : adoPrePickSize(nc, oldT || s.d.pref);
      return adoPreRender();
    }
    const sb = t.closest('[data-adoc-pre-sz]');
    if (sb && !sb.disabled) {
      s.vid[adoPreKind().k] = Number(sb.getAttribute('data-adoc-pre-sz'));
      return adoPreRender();
    }
    const ab = t.closest('[data-adoc-pre-add]');
    if (ab && !ab.disabled) {
      const vid = s.vid[adoPreKind().k];
      if (!vid) return;
      s.busy = true;
      ab.disabled = true;
      ab.textContent = s.d.t.adding;
      try {
        await rawAdd([{ id: vid, quantity: s.q || 1 }]);
        adoPreMark(true);
      } catch (err) {
        /* když přidání selže, zákazníka nezdržujeme – otevře se šuplík s tím, co v košíku je */
      }
      /* šuplík se překreslí s doplňkem dřív, než se otevře */
      try {
        await adoRefreshCart();
      } catch (err) {}
      adoPreClose();
    }
  });
  adoPreDlg = dlg;
  return dlg;
}
function adoPreOpen(d, after) {
  const dlg = adoPreEnsure();
  const color = {};
  const vid = {};
  d.k.forEach((k) => {
    const c = k.c.find((x) => x.c === 'w' && x.av) || k.c.find((x) => x.av);
    color[k.k] = c.c;
    vid[k.k] = adoPrePickSize(c, d.pref);
  });
  /* předvoleno 2 ks, když se sleva za kusy v košíku uplatní (tok), jinak 1 ks – jako v košíku */
  const q = d.k[0].tok === 1 ? 2 : 1;
  adoPreState = { d, kind: d.k[0].k, color, vid, q, box: dlg.querySelector('[data-adoc-pre-box]') };
  adoPreAfter = after;
  adoPreRender();
  dlg.showModal();
  const add = dlg.querySelector('.adoc-pre__add');
  if (add) add.focus({ preventScroll: true });
}
/* data okna z HTML sekce šuplíku (jen košík bez zaplacených Supreme trenek/ponožek je obsahuje); jen skladem */
function adoPreParse(html) {
  const m = /<script[^>]*data-adoc-pre[^>]*>([\s\S]*?)<\/script>/.exec(html || '');
  if (!m) return null;
  let d = null;
  try {
    d = JSON.parse(m[1]);
  } catch (e) {
    return null;
  }
  d.k = (d.k || [])
    .map((k) => ({ ...k, c: k.c.map((c) => ({ ...c, av: !!c.av && c.v.some((v) => v.av) })) }))
    .filter((k) => k.c.some((c) => c.av));
  return d.k.length ? d : null;
}
function adoPreDrawerOpen() {
  return !!document.querySelector('cart-drawer-component dialog[open]');
}
/* má se po tomhle přidání do košíku rozhodovat o okně? */
function adoPreShouldArm(url, init) {
  if (!url || url.origin !== window.location.origin || !/\/cart\/add(\.js)?$/.test(url.pathname)) return false;
  if (!init || String(init.method || 'GET').toUpperCase() !== 'POST') return false;
  if (/\/cart\/?$/.test(window.location.pathname)) return false;
  if (adoPreBlocked() || adoPreIsOpen() || adoPreDrawerOpen()) return false;
  if (!document.querySelector('cart-drawer-component')) return false;
  /* samotný dárek (_gift – agb-gift.js, adoGiftTopUp) okno nespouští; set s dárkem ano */
  const b = init.body;
  try {
    if (typeof b === 'string') {
      const j = JSON.parse(b);
      const its = j && (j.items || (j.id ? [j] : []));
      if (its && its.length && its.every((i) => i.properties && i.properties._gift)) return false;
    }
    if (b instanceof FormData) for (const key of b.keys()) if (key.indexOf('_gift') > -1) return false;
  } catch (e) {}
  return true;
}
if (!window.__adoPreFetchPatched) {
  window.__adoPreFetchPatched = true;
  const prevFetch = window.fetch;
  window.fetch = function (input, init) {
    let arm = false;
    try {
      const raw = typeof input === 'string' ? input : input instanceof URL ? input.href : input && input.url;
      arm = adoPreShouldArm(raw ? new URL(raw, window.location.origin) : null, init);
    } catch (e) {}
    const res = prevFetch.apply(this, arguments);
    if (arm) {
      const p = res
        .then(async (r) => {
          if (!r.ok) return null;
          const j = await r.clone().json();
          if (!j || j.status) return null;
          let html = '';
          if (j.sections && Object.keys(j.sections).length) html = Object.values(j.sections).join('');
          else {
            const ids = sectionIds();
            if (!ids.length) return null;
            const sj = await (await prevFetch(`${window.location.pathname}?sections=${ids.join(',')}`, { cache: 'no-store' })).json();
            html = Object.values(sj || {}).join('');
          }
          return adoPreParse(html);
        })
        .catch(() => null);
      adoPreWait = { p, t: Date.now() };
    }
    return res;
  };
}
/* šuplík košíku: otevření po přidání se podrží, dokud není jasné, jestli ukázat okno */
customElements.whenDefined('cart-drawer-component').then((C) => {
  const proto = C && C.prototype;
  if (!proto || proto.__adoPreGate || typeof proto.showDialog !== 'function') return;
  proto.__adoPreGate = true;
  const orig = proto.showDialog;
  proto.showDialog = function () {
    const self = this;
    const go = () => orig.call(self);
    /* okno je otevřené / rozhoduje se → šuplík se otevře až potom (žádný dvojí šuplík) */
    if (adoPreIsOpen()) {
      if (!adoPreAfter) adoPreAfter = go;
      return;
    }
    if (adoPreHold) return;
    const w = adoPreWait;
    adoPreWait = null;
    if (!w || Date.now() - w.t > 15000) return go();
    adoPreHold = true;
    let done = false;
    const finish = (d) => {
      if (done) return;
      done = true;
      adoPreHold = false;
      if (!d || adoPreBlocked() || adoPreDrawerOpen()) return go();
      adoPreMark(false);
      try {
        adoPreOpen(d, go);
      } catch (e) {
        adoPreAfter = null;
        go();
      }
    };
    setTimeout(() => finish(null), 3000);
    w.p.then(finish, () => finish(null));
  };
});
